
export const catalogPages = [
  {
    id: 1,
    image: "https://readdy.ai/api/search-image?query=Luxury%20carpet%20catalog%20cover%20page%20elegant%20dark%20burgundy%20background%20with%20gold%20ornamental%20border%20premium%20Turkish%20carpet%20brand%20logo%20centered%20sophisticated%20typography%202026%20collection%20high%20end%20editorial%20design%20professional%20catalog%20cover&width=800&height=1100&seq=cat001&orientation=portrait",
    title: "2026 Koleksiyon Kapak"
  },
  {
    id: 2,
    image: "https://readdy.ai/api/search-image?query=Modern%20luxury%20living%20room%20interior%20with%20large%20elegant%20patterned%20carpet%20on%20floor%20contemporary%20furniture%20warm%20ambient%20lighting%20high%20ceiling%20minimalist%20decor%20professional%20interior%20photography%20showroom%20style%20clean%20composition&width=800&height=1100&seq=cat002&orientation=portrait",
    title: "Oturma Odası Koleksiyonu"
  },
  {
    id: 3,
    image: "https://readdy.ai/api/search-image?query=Close%20up%20detail%20shot%20of%20premium%20handwoven%20carpet%20texture%20intricate%20geometric%20patterns%20rich%20burgundy%20gold%20and%20cream%20colors%20soft%20wool%20fibers%20visible%20macro%20photography%20studio%20lighting%20catalog%20product%20shot%20white%20background&width=800&height=1100&seq=cat003&orientation=portrait",
    title: "Desen Detayları"
  },
  {
    id: 4,
    image: "https://readdy.ai/api/search-image?query=Elegant%20bedroom%20interior%20design%20with%20luxurious%20soft%20carpet%20under%20bed%20warm%20cozy%20atmosphere%20neutral%20tones%20beige%20cream%20modern%20bedroom%20furniture%20natural%20light%20from%20window%20professional%20real%20estate%20photography%20style&width=800&height=1100&seq=cat004&orientation=portrait",
    title: "Yatak Odası Tasarımları"
  },
  {
    id: 5,
    image: "https://readdy.ai/api/search-image?query=Carpet%20showroom%20display%20multiple%20rolled%20carpets%20standing%20vertically%20various%20colors%20and%20patterns%20professional%20showroom%20lighting%20modern%20retail%20space%20clean%20organized%20display%20warm%20ambient%20light%20commercial%20photography&width=800&height=1100&seq=cat005&orientation=portrait",
    title: "Showroom Koleksiyonu"
  },
  {
    id: 6,
    image: "https://readdy.ai/api/search-image?query=Modern%20dining%20room%20with%20beautiful%20area%20rug%20under%20dining%20table%20overhead%20chandelier%20elegant%20place%20settings%20contemporary%20interior%20design%20warm%20wood%20tones%20professional%20architectural%20photography%20magazine%20quality&width=800&height=1100&seq=cat006&orientation=portrait",
    title: "Yemek Odası Halıları"
  },
  {
    id: 7,
    image: "https://readdy.ai/api/search-image?query=Traditional%20Turkish%20carpet%20patterns%20collection%20four%20different%20designs%20arranged%20in%20grid%20layout%20rich%20colors%20red%20navy%20gold%20cream%20intricate%20floral%20and%20geometric%20motifs%20flat%20lay%20photography%20catalog%20style%20white%20background&width=800&height=1100&seq=cat007&orientation=portrait",
    title: "Geleneksel Desenler"
  },
  {
    id: 8,
    image: "https://readdy.ai/api/search-image?query=Minimalist%20modern%20office%20space%20with%20contemporary%20abstract%20pattern%20carpet%20clean%20lines%20neutral%20colors%20gray%20beige%20white%20professional%20workspace%20natural%20light%20large%20windows%20architectural%20interior%20photography&width=800&height=1100&seq=cat008&orientation=portrait",
    title: "Ofis & Ticari Halılar"
  },
  {
    id: 9,
    image: "https://readdy.ai/api/search-image?query=Luxury%20hotel%20lobby%20with%20grand%20ornamental%20carpet%20covering%20marble%20floor%20elegant%20columns%20crystal%20chandelier%20opulent%20interior%20design%20warm%20golden%20lighting%20five%20star%20hotel%20atmosphere%20professional%20hospitality%20photography&width=800&height=1100&seq=cat009&orientation=portrait",
    title: "Otel & Proje Halıları"
  },
  {
    id: 10,
    image: "https://readdy.ai/api/search-image?query=Carpet%20manufacturing%20factory%20production%20line%20weaving%20looms%20colorful%20yarn%20threads%20industrial%20textile%20machinery%20professional%20factory%20photography%20warm%20lighting%20Turkish%20carpet%20production%20craftsmanship%20quality%20control&width=800&height=1100&seq=cat010&orientation=portrait",
    title: "Üretim & Kalite"
  }
];
